export default __webpack_public_path__ + "static/media/landingimage5.e53fbb25.png";